<template>
    <div>
        <div class="container-fluid auth" id="reset-password">
            <div class="row form w-100">
                <div class="col-xl-7 col-lg-5 col-md-2 col-sm-1"></div>
                <div class="col-xl-4 col-lg-6 col-md-8 col-sm-10 reset-form">
                    <div class="card mb-5 mt-5 d-none d-sm-block">
                        <!-- <div class="card-header">Login</div> -->
                        <div class="card-body">
                            <h1
                                class="text-center mb-4 mt-4 text-white header-title"
                            >
                                RESET PASSWORD
                            </h1>
                            <form
                                @submit.prevent="updatePassword"
                                :class="{ submitting: this.submitting }"
                            >
                                <div class="form-group row">
                                    <div class="col-md-2"></div>
                                    <div class="col-md-8">
                                        <input
                                            type="email"
                                            class="form-control"
                                            name="email"
                                            v-bind:class="{
                                                'is-invalid': errors.email
                                            }"
                                            value=""
                                            required
                                            autofocus
                                            placeholder="E-mail Address"
                                            v-model="fields.email"
                                        />
                                        <span
                                            class="invalid-feedback"
                                            role="alert"
                                            v-if="errors.email"
                                        >
                                            <strong>{{ errors.email }}</strong>
                                        </span>
                                    </div>
                                    <div class="col-md-2"></div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-md-2"></div>
                                    <div class="col-md-8">
                                        <input
                                            type="password"
                                            class="form-control"
                                            name="password"
                                            v-bind:class="{
                                                'is-invalid': errors.password
                                            }"
                                            value=""
                                            required
                                            autofocus
                                            placeholder="Password"
                                            v-model="fields.password"
                                        />
                                        <span
                                            class="invalid-feedback"
                                            role="alert"
                                            v-if="errors.password"
                                        >
                                            <strong>{{
                                                errors.password
                                            }}</strong>
                                        </span>
                                    </div>
                                    <div class="col-md-2"></div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-md-2"></div>
                                    <div class="col-md-8">
                                        <input
                                            type="password"
                                            class="form-control"
                                            name="password_confirmation"
                                            v-bind:class="{
                                                'is-invalid': errors.email
                                            }"
                                            value=""
                                            required
                                            autofocus
                                            placeholder="Confirm Password"
                                            v-model="
                                                fields.password_confirmation
                                            "
                                        />
                                    </div>
                                    <div class="col-md-2"></div>
                                </div>
                                <div class="form-group row mb-5">
                                    <div class="col-md-12 text-center">
                                        <button
                                            type="submit"
                                            class="btn btn-primary"
                                            :class="{
                                                submitting: this.submitting
                                            }"
                                            :disabled="this.submitting"
                                        >
                                            Reset Password
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1"></div>
            </div>
        </div>
        <div class="card-body d-block d-sm-none">
            <h1 class="text-center mb-4 mt-4 header-title">RESET PASSWORD</h1>
            <form
                @submit.prevent="updatePassword"
                :class="{
                    submitting: this.submitting
                }"
                :disabled="this.submitting"
            >
                <div class="form-group row">
                    <div class="col-md-2"></div>
                    <div class="col-md-8">
                        <input
                            type="email"
                            class="form-control"
                            name="email"
                            v-bind:class="{ 'is-invalid': errors.email }"
                            value=""
                            required
                            autofocus
                            placeholder="E-mail Address"
                            v-model="fields.email"
                        />
                        <span
                            class="invalid-feedback"
                            role="alert"
                            v-if="errors.email"
                        >
                            <strong>{{ errors.email }}</strong>
                        </span>
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group row">
                    <div class="col-md-2"></div>
                    <div class="col-md-8">
                        <input
                            type="password"
                            class="form-control"
                            name="password"
                            v-bind:class="{ 'is-invalid': errors.password }"
                            value=""
                            required
                            autofocus
                            placeholder="Password"
                            v-model="fields.password"
                        />
                        <span
                            class="invalid-feedback"
                            role="alert"
                            v-if="errors.password"
                        >
                            <strong>{{ errors.password }}</strong>
                        </span>
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group row">
                    <div class="col-md-2"></div>
                    <div class="col-md-8">
                        <input
                            type="password"
                            class="form-control"
                            name="password_confirmation"
                            v-bind:class="{ 'is-invalid': errors.email }"
                            value=""
                            required
                            autofocus
                            placeholder="Confirm Password"
                            v-model="fields.password_confirmation"
                        />
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group row mb-5">
                    <div class="col-md-12 text-center">
                        <button
                            type="submit"
                            class="btn btn-primary"
                            :class="{
                                submitting: this.submitting
                            }"
                            :disabled="this.submitting"
                        >
                            Reset Password
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    props: ["_token", "email_old"],
    data() {
        return {
            fields: {
                email: "",
                password: "",
                password_confirmation: "",
                _token: this._token,
                token: ""
            },
            errors: {
                email: "",
                password: ""
            },
            submitting: false
        };
    },
    created() {
        this.fields.email = this.email_old;
        const currentUrl = window.location.pathname;
        this.fields.token = currentUrl.split("/")[3];
    },
    methods: {
        updatePassword() {
            this.submitting = true;
            fetch("/password/reset", {
                method: "post",
                body: JSON.stringify(this.fields),
                headers: {
                    "content-type": "application/json",
                    Accept: "application/json"
                }
            })
                .then(res => res.json())
                .then(data => {
                    this.submitting = false;
                    if (typeof data.errors != "undefined") {
                        if (typeof data.errors.email != "undefined") {
                            this.errors.email = data.errors.email[0];
                        }
                        if (typeof data.errors.password != "undefined") {
                            this.errors.password = data.errors.password[0];
                        }
                    } else {
                        if (typeof data.message != "undefined") {
                            Swal.fire("Great!", data.message, "success");
                            window.location.reload();
                        }
                    }
                })
                .catch(err => {
                    this.submitting = false;
                    console.log(err);
                });
        }
    }
};
</script>

<style scoped>
#reset-password {
    margin: 0;
    padding: 0;
    min-width: 100%;
    min-height: 100vh;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    background-image: url("/storage/imgs/tigers/Medium_WW2122527_Large.jpg");
    color: white;
}
#reset-password .form {
    min-height: 100vh;
}
#reset-password .reset-form {
    display: flex;
    justify-content: center;
    align-items: center;
}
#reset-password .card {
    width: 100%;
    background-color: rgba(0, 0, 0, 0.6);
}
.header-title {
    font-family: "WWF";
    font-size: 3.5em;
}
#reset-password button {
    background-color: #f58220;
    border: none;
    font-size: 1.5rem;
    border-radius: 0px !important;
    font-family: "WWF";
    text-transform: uppercase;
}
#reset-password a {
    color: white;
}

@media only screen and (min-width: 575px) {
    form.submitting:after {
        background-color: rgba(0, 0, 0, 0.3);
    }
}
@media only screen and (max-width: 575px) {
    #reset-password {
        min-height: 30vh;
    }
    #reset-password .form {
        min-height: 30vh;
    }
}

@media only screen and (max-width: 768px) {
    .header-title[data-v-06688fcd] {
        font-size: 2rem;
        margin-top: 1rem !important;
    }
    .btn-primary {
        background-color: #f07d00;
        border-color: #f07d00;
    }
    .btn-primary:not(:disabled):not(.disabled):active,
    .btn-primary:not(:disabled):not(.disabled).active,
    .show > .btn-primary.dropdown-toggle {
        background-color: #d06d01;
        border-color: #d06d01;
    }
}
</style>
<style>
header {
    background-color: transparent;
    position: absolute;
    width: 100%;
    top: 0;
}
.navbar-brand img {
    margin-top: -50px;
    max-width: 70px;
}

a.nav-link-main.nav-link {
    padding-left: 10px;
}
@media only screen and (max-width: 992px) {
    .navbar-brand img {
        margin-top: 0px;
    }
}
@media only screen and (max-width: 768px) {
    .become-a-protector-ln {
        background-color: #f07d00;
        color: white !important;
    }
}
</style>
